import HttpClienteToken from '../../services/HttpClientToken';

import { TipoAudienciaProps } from '../../interfaces/catalogos/TipoAudienciaInterface';

export const TipoAudiencia = () => {

    return new Promise<TipoAudienciaProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoAudiencia/', token)
            .then( ({ data } : { data : TipoAudienciaProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerTipoAudiencia = () => {

    return new Promise<TipoAudienciaProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoAudiencia/ObtenerTipoAudiencia', token)
            .then( ({ data } : { data : TipoAudienciaProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerTipoAudienciaMateria = () => {

    return new Promise<TipoAudienciaProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoAudiencia/ObtenerTipoAudienciaMateria', token)
            .then( ({ data } : { data : TipoAudienciaProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarTipoAudiencia = ( params: TipoAudienciaProps ) => {

    return new Promise<TipoAudienciaProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoAudiencia/Actualizar', params, token)
            .then( ({ data } : { data : TipoAudienciaProps } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve({
                    idTipoAudiencia: 0,
                    descripcion: '',
                    idMateria: 0,
                    activo: false,
                    referencia: 0,
                    duracion: 0,
                    plazoInicial: 0,
                    plazoFinal: 0,
                });
            });
        }

    });

}

export const AgregarTipoAudiencia = ( params: TipoAudienciaProps ) => {

    return new Promise<TipoAudienciaProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoAudiencia/Agregar', params, token)
            .then( ({ data } : { data : TipoAudienciaProps } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve({
                    idTipoAudiencia: 0,
                    descripcion: '',
                    idMateria: 0,
                    activo: false,
                    referencia: 0,
                    duracion: 0,
                    plazoInicial: 0,
                    plazoFinal: 0,
                });
            });
        }

    });

}